import { render, staticRenderFns } from "./SpecNewRow.vue?vue&type=template&id=4fa5c1a4&scoped=true&lang=pug&"
import script from "./SpecNewRow.vue?vue&type=script&lang=js&"
export * from "./SpecNewRow.vue?vue&type=script&lang=js&"
import style0 from "./SpecNewRow.vue?vue&type=style&index=0&id=4fa5c1a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5c1a4",
  null
  
)

export default component.exports